export const MODAL_IDS = {
    EXAMPLE_DESCRIPTION_MODAL: {
        title: 'example-description-modal-title',
        subheading: 'example-description-modal-subheading',
        triggerElement: 'example-description-modal-trigger',
    },
};
